import { FieldLabel, TextInput } from '../../components/Primitives.jsx';
import { ColSelect } from '../shared/ColSelect.jsx';

// ── Mid (substring) inspector ───────────────────────────────────────────
export function MidInspector({ step, onChange }) {
  const c = step.config || {};
  const u = (patch) => onChange({ ...step, config: { ...c, ...patch } });
  return (
    <div>
      <FieldLabel>Column</FieldLabel>
      <ColSelect value={c.column} onChange={(v) => u({ column: v })} />
      <FieldLabel hint="0-indexed start position">Start index</FieldLabel>
      <TextInput mono value={String(c.start ?? 0)} onChange={(v) => u({ start: parseInt(v) || 0 })} placeholder="0" />
      <FieldLabel hint="Number of characters to extract">Length</FieldLabel>
      <TextInput mono value={c.length != null ? String(c.length) : ''} onChange={(v) => u({ length: v.trim() === '' ? null : (parseInt(v) || 0) })} placeholder="e.g. 10 (blank = rest)" />
      <FieldLabel hint="Defaults to column_mid">Target column</FieldLabel>
      <TextInput value={c.target || ''} onChange={(v) => u({ target: v })} placeholder={`${c.column || 'col'}_mid`} />
    </div>
  );
}
